import { render, staticRenderFns } from "./UserRecharge.vue?vue&type=template&id=f70184a8&scoped=true&"
import script from "./UserRecharge.vue?vue&type=script&lang=js&"
export * from "./UserRecharge.vue?vue&type=script&lang=js&"
import style0 from "./UserRecharge.vue?vue&type=style&index=0&id=f70184a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../frontend-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f70184a8",
  null
  
)

export default component.exports